import React, { useState } from 'react';
import { ChevronDown, ChevronUp, BookOpen, CheckCircle2 } from 'lucide-react';
const chaptersData = [{
  title: 'CAPÍTULO 1 — FUNDAMENTOS DEL INSTRUCTOR DE HANDBALL',
  subtitle: 'Cómo dejar de improvisar entrenamientos y organizar clases más profesionales',
  content: ['Qué hace realmente un buen profesor de handball', 'Cómo estructurar clases efectivas', 'Cómo trabajar distintas edades (Infantiles, Adolescentes, Adultos)', 'Organización eficiente del entrenamiento', 'Psicología del entrenador', 'Problemas comunes y soluciones rápidas', 'Mentalidad del entrenador eficiente']
}, {
  title: 'CAPÍTULO 2 — CLASES INFANTILES RESUELTAS',
  subtitle: 'Sistema completo para entrenar niños sin aburrimiento',
  content: ['Bases del handball infantil', 'Clases para 5–7 años', 'Clases para 8–10 años', 'Clases para 11–12 años', 'Juegos y dinámicas grupales', 'Cómo mantener la atención infantil', '20 clases infantiles completas']
}, {
  title: 'CAPÍTULO 3 — CLASES PARA ADOLESCENTES',
  subtitle: 'Entrenamientos modernos para mejorar rendimiento y competitividad',
  content: ['Desarrollo físico y deportivo adolescente', 'Técnica individual', 'Defensa y táctica', 'Preparación física aplicada', 'Entrenamientos competitivos', 'Motivación y mentalidad', '20 entrenamientos adolescentes completos']
}, {
  title: 'CAPÍTULO 4 — CLASES PARA ADULTOS Y AMATEUR COMPETITIVO',
  subtitle: 'Sistemas tácticos y entrenamientos de rendimiento',
  content: ['Cómo entrenar adultos', 'Técnica avanzada aplicada', 'Sistemas tácticos', 'Preparación física específica', 'Gestión grupal competitiva', 'Entrenamientos de emergencia', '20 entrenamientos completos para adultos']
}, {
  title: 'CAPÍTULO 5 — EJERCICIOS, DRILLS Y RECURSOS VISUALES',
  subtitle: 'Biblioteca completa de ejercicios para profesores',
  content: ['Drills de velocidad y reacción', 'Ejercicios técnicos', 'Ejercicios tácticos', 'Juegos competitivos', 'Entrenamientos improvisados y emergencias', 'Planificación mensual y anual', 'Biblioteca visual con +100 ejercicios ilustrados']
}, {
  title: 'CAPÍTULO 6 — NUTRICIÓN, PREVENCIÓN Y RENDIMIENTO',
  subtitle: 'Cómo mejorar el rendimiento y reducir lesiones',
  content: ['Nutrición aplicada al handball', 'Hidratación y recuperación', 'Suplementación básica', 'Prevención de lesiones (Rodilla, Tobillo, Hombro)', 'Movilidad y activación', 'Manejo de cargas y fatiga', 'Guías rápidas para entrenadores']
}];
export function ChaptersAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <h2 className="text-3xl md:text-4xl font-oswald font-bold text-center text-slate-900 mb-10 uppercase" data-id="element-70">
          6 capítulos que{' '}
          <span className="text-blue-600" data-id="element-71">evolucionan tu clase:</span>
        </h2>

        <div className="space-y-4" data-id="element-72">
          {chaptersData.map((chapter, index) => <div key={index} className="border border-slate-200 rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-73">
              <button onClick={() => toggleAccordion(index)} className={`w-full text-left px-6 py-5 flex items-center justify-between transition-colors ${openIndex === index ? 'bg-blue-50' : 'hover:bg-slate-50'}`} data-id="element-74">
                <div className="flex items-center gap-4 pr-4" data-id="element-75">
                  <div className={`p-2 rounded-lg ${openIndex === index ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-500'}`} data-id="element-76">
                    <BookOpen className="w-6 h-6" data-id="element-77" />
                  </div>
                  <div data-id="element-78">
                    <h3 className="font-oswald font-bold text-xl text-slate-900" data-id="element-79">
                      {chapter.title}
                    </h3>
                    <p className="text-sm text-slate-600 font-medium mt-1" data-id="element-80">
                      {chapter.subtitle}
                    </p>
                  </div>
                </div>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-blue-600 flex-shrink-0" data-id="element-81" /> : <ChevronDown className="w-6 h-6 text-slate-400 flex-shrink-0" data-id="element-82" />}
              </button>

              {openIndex === index && <div className="px-6 py-5 bg-white border-t border-slate-100" data-id="element-83">
                  <ul className="space-y-3" data-id="element-84">
                    {chapter.content.map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-700" data-id="element-85">
                        <CheckCircle2 className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" data-id="element-86" />
                        <span data-id="element-87">{item}</span>
                      </li>)}
                  </ul>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}